import foto1 from "./foto.png";
import foto2 from "./foto3.png";
import foto4 from "./foto4.png";
import foto5 from "./main.png.png";

export const data = [
  {
    id: new Date().getFullYear(),
    img: foto4,
    explanation:
      " These ultra sleek and contemporary new villas are situated on a seafront",
  },

  {
    id: new Date().getFullYear() + 1,
    img: foto2,
    explanation:
      " These ultra sleek and contemporary new villas are situated on a seafront",
  },

  {
    id: new Date().getFullYear() + 2,
    img: foto4,
    explanation:
      " These ultra sleek and contemporary new villas are situated on a seafront",
  },

  {
    id: new Date().getFullYear() + 3,
    img: foto2,
    explanation:
      " These ultra sleek and contemporary new villas are situated on a seafront",
  },
];

export const data2 = [
  {
    header: "Properties",
    line1: "Wise Review",
    line2: "Open Wise Account",
    line3: "N26",
    line4: "E Residency Countrie",
    line5: "Wise Review",
    id : 1,
  },
  {
    header: "Article",
    line1: "Wise Review",
    line2: "Open Wise Account",
    line3: "N26",
    line4: "E Residency Countrie",
    line5: "Wise Review",
    id : 2,
  },
  {
    header: "Calculator",
    line1: "Wise Review",
    line2: "Open Wise Account",
    line3: "N26",
    line4: "E Residency Countrie",
    line5: "Wise Review",
    id : 3,
  },
  {
    header: "About",
    line1: "Wise Review",
    line2: "Open Wise Account",
    line3: "N26",
    line4: "E Residency Countrie",
    line5: "Wise Review",
    id : 4,
  },
];
